module.exports = __webpack_public_path__ + "static/img/4.c762b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/4.png
// module id = 1HAy
// module chunks = 0